import { filesSearchId } from '../../../../../../../../../config/constants.js';

export default () => {
    if ($$(filesSearchId).isVisible()) {
        $$(filesSearchId).hide();
    } else {
        $$(filesSearchId).show();
    }
};
